export const Namespace = 'site';
export const NamespaceSeparator = '/';

export const SiteBondsCategory = 'PageEntity';

export const HeaderStackName = 'Header';
export const FooterStackName = 'Footer';

export const WebsiteSetupChecklistItems = Object.freeze([
  'checkedDesign',
  'checkedHomepage',
  'checkedCustomPage',
  'checkedPrivacyPages',
  'checkGoingLiveInfo',
]);
